import * as React from 'react'
import { Field } from 'formik'
import { MuiMobileDatePickerFormik } from '@user/components/Formik/MuiMobileDatePickerFormik'
import { OptionalField } from './typings'
import { styles } from './useStyles'

type Props = {
  disabled: boolean
  disablePast?: boolean
  label: string
  name: string
  size?: string
  clearable?: boolean
  whiteBackground?: boolean
  isSaveForLaterType?: boolean
} & OptionalField

export function OpportunityDatePicker(props: Props) {
  const {
    disabled,
    disablePast,
    hideOptional,
    label,
    name,
    required,
    clearable,
    size = 'medium',
    whiteBackground = false,
    isSaveForLaterType = false,
  } = props

  return hideOptional && !required ? null : (
    <Field
      fullWidth
      name={name}
      label={label}
      component={MuiMobileDatePickerFormik}
      sx={whiteBackground ? styles.input : styles.transparent}
      margin="normal"
      disabled={disabled}
      required={required}
      clearable={clearable}
      size={size}
      disablePast={disablePast}
      data-test-id="opportunityDatePicker"
      isOpp
      isSaveForLaterType={isSaveForLaterType}
    />
  )
}
